import {
    QidProductDocument,
    QidProductDocumentCreate,
    MtDriveVersion,
} from "server/models"
import { GET, DELETE, POST } from "client/store/utils"
import { QidProductDocumentList } from "./types"

export const LoadAllQidProductDocuments = (productId: number) => (
    GET(`/qidProductDocument/all/${productId}`)
    .then((documents: QidProductDocument[]) => {
        const documentList: QidProductDocumentList = {}
        const documentIds: number[] = []

        documents.forEach((document) => {
            documentList[document.fileId] = document
            documentIds.push(document.fileId)
        })
        return { documentList, documentIds }
    })
)

export const LoadDefaultQidProductDocument = (productId: number) => (
    GET(`/qidProductDocument/all/${productId}`)
    .then((documents: QidProductDocument[]) => {
        let reference: MtDriveVersion = null
        for (let i = 0; i < documents.length; i++) {
            const document = documents[i]
            const { file } = document
            if (file.datapointReference) {
                for (let k = 0; k < file.versions.length; k++) {
                    const version = file.versions[k]
                    if (version.default) {
                        reference = version
                        break
                    }
                }
                break
            }
        }
        return reference
    })
)

export const AddQidProductDocument = (
    productId: number,
    fileId: number,
) => {
    const data: QidProductDocumentCreate = {
        productId,
        fileId,
    }

    return POST(
        "/qidProductDocument/add",
        JSON.stringify(data),
    )
}

export const DeleteQidProductDocument = (
    productId: number,
    fileId: number,
) => (
    DELETE(`/qidProductDocument/delete/${productId}/${fileId}`)
    .then((removedRows: number) => removedRows)
)
